import { useContext, useEffect, useState } from "react"
import { getData } from "src/actions/getData";
import MiniInfoButton from "src/components/MiniInfoButton";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import shopContext from "src/context/shopContext";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { TbReload } from "react-icons/tb";
import { FilterFn } from "src/components/Table/FilterFn";
import FilterColumn from "src/components/Table/FilterColumn";
import { TbHelpSquareRounded } from "react-icons/tb";

import moment from 'jalali-moment';
import Hintbox from "src/components/Hintbox";
import Accordion from "src/components/Accordion";

export default function FinancialSales() {

    const { sales, setSales } = useContext(shopContext)

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        if (!sales) {
            getData(setSales, "/order-items", {}, signal);
        }

        return () => {
            controller.abort();
        };
    }, [])

    const columns = [
        {
            id: "featuredImage",
            cell: (info) => (<img className="w-[80px] max-w-[80px] rounded-lg" src={`${process.env.REACT_APP_CDN_URL}/thumbnail/${info.row.original.product.id}/${info.getValue()}`} />),
            header: "تصویر",
        },
        {
            id: "title",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام محصول",
        },
        {
            id: "sku",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "sku",
        },
        {
            id: "orderNumber",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره سفارش",
        },
        {
            id: "seller",
            cell: (info) => info.getValue() ? info.getValue() : "bodoroj",
            header: "فروشنده",
        },
        {
            id: "extraId",
            cell: (info) => info.getValue() > 0 ? info.getValue() : "---",
            header: "شماره فاکتور سپیدار",
        },
        {
            id: "taxClass",
            cell: (info) => info.getValue() ? "%" + info.getValue() : "---",
            header: "کلاس مالیات",
        },
        {
            id: "quantity",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تعداد",
        },
        {
            id: "price",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "مبلغ واحد (با مالیات)",
        },
        {
            id: "salePrice",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "مبلغ واحد فروش ویژه (با مالیات)",
        },
        {
            id: "taxFreeBasePrice",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "مبلغ واحد",
        },
        {
            id: "taxFreeTotalPrice",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "مبلغ کل",
        },
        {
            id: "financialTotalDiscount",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "مبلغ تخفیف",
        },
        {
            id: "addition",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "مبلغ اضافات",
        },
        {
            id: "calculatedTotalPrice",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "مبلغ کل پس از تخفیف و اضافات",
        },
        {
            id: "totalNetTax",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "جمع مالیات و عوارض",
        },
        {
            id: "calculatedFactor",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "خالص فاکتور",
        },
        {
            id: "amortizedPaidShipping",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "هزینه ارسال پرداخت شده سرشکن",
        },
        {
            id: "amortizedDiscountShipping",
            cell: (info) => numberWithCommas(info.getValue()) + " ریال",
            header: "تخفیف ارسال سرشکن شده",
        },
        {
            id: "status",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "وضعیت سفارش",
        },
        {
            id: "paymentMethod",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "روش پرداخت",
        },
        {
            id: "date_paid",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue(), "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            filterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue) => {
                    return <FilterColumn setFilterValue={setFilterValue} type="date" />;
                },
            },
            header: "تاریخ پرداخت",
        },
    ];

    return (
        <>
            <PageHeader
                title="لیست فروش‌ها"
            // btnTitle="بروزرسانی"
            // handleClick={() => {
            //     setSales();
            //     getData(() => { }, "/orders/purgeCache");
            //     getData(setSales, "/sales");
            // }}
            // btnIcon={<TbReload className="ml-1" size="20" />}
            // isBtnLoading={!sales}
            />
            <Accordion title="نکات راهنما" icon={<TbHelpSquareRounded className="text-gray-400" />} hasVerticalLine={true} >
                <Hintbox text="لیست تمام اقلام فروش رفته در سایت به استثنا سفارشات در حال انجام - محاسبات ارائه شده در این صفحه بر مبنا نحوه محاسبه در سپیدار هستند و تلاش شده از ستون‌های مشابه با سپیدار برای راحتی کار استفاده شود." type="info" />
                <Hintbox text="برای بررسی اینکه هر آیتمی از سفارش در کدامیک از فاکتورهای سپیدار درج شده می‌توان از ستون شماره فاکتور سپیدار کمک گرفت - فاکتورهای سپیدار با تاخیر 5 روزه نسبت به فروش، ثبت می‌شوند." type="info" />
                <Hintbox text="کلاس‌های مالیات مورد استفاده در این صفحه و سایر بخش ها مستقیما از سپیدار فراخوانی می‌شوند. بنابراین برای ویرایش، لازم است تا مقادیر آن‌ها در سپیدار بروزرسانی شوند." type="alert" />
            </Accordion>
            <Table data={sales} columns={columns} CSVExportPermission="exportSales" />
        </>
    )
}
